import { render, staticRenderFns } from "./LocaleRadioButtonGroup.vue?vue&type=template&id=15c4c59c&"
import script from "./LocaleRadioButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./LocaleRadioButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports